import React, { useCallback, useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MediaContext } from "./media-context";

import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import EditColumn from "./EditColumn";
import Image from "../../components/Image";
import NewThumbnailDialog from "./NewThumbnailDialog";

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },

  item: {
    padding: theme.spacing(0, 8, 8, 8),
  },

  thumbnailOverlay: {
    height: "150px",
    width: "150px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
    backgroundColor: "#E5E5E5",
  },

  thumbnailEdit: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
  },

  emptyThumbnail: {
    fontSize: "120px",
    color: theme.palette.primary.disabled,
  },

  editIcon: {
    color: "white",
  },

  locked: {
    marginLeft: theme.spacing(2),
  },
}));

const NewOrgLogoOverlay = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [uploading, setUploading] = useState(false);

  const onEditClick = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleSave = useCallback(
    async (url, file) => {
      try {
        setUploading(true);

        console.log("Upload Complete...");
        context.setOrgLogoUrl(url);
        context.setOrgLogoFile(file);
        setUploading(false);
        setDialogOpen(false);
      } catch (err) {
        console.log(err);
      }
    },
    [context],
  );

  const formBuilder = useCallback(
    handlers => {
      return (
        <Box ml={2}>
          <Box mb={4}>
            <Typography variant="h6" noWrap>
              Organization Logo
            </Typography>
          </Box>

          <Box ml={2} classes={{ root: classes.thumbnailOverlay }}>
            <Image alt="Organization Logo" src={context.orgLogoUrl} />

            <IconButton
              color="primary"
              classes={{ root: classes.thumbnailEdit }}
              onClick={onEditClick}
            >
              <EditIcon fontSize="large" classes={{ root: classes.editIcon }} />
            </IconButton>
            <NewThumbnailDialog
              dialogTitle="New Organization Logo"
              inputTitle="Upload a new organization logo"
              visible={dialogOpen}
              uploading={uploading}
              media={context.media}
              accept="png, image/png, jpg, jpeg, image/jpeg, image/jpg"
              onCancel={handleCancel}
              onSave={handleSave}
            />
          </Box>
        </Box>
      );
    },
    [
      context,
      classes,
      dialogOpen,
      uploading,
      handleSave,
      handleCancel,
      onEditClick,
    ],
  );

  return <EditColumn className={classes.item} formBuilder={formBuilder} />;
};

export default NewOrgLogoOverlay;
